import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import * as PDFJSLib from "pdfjs-dist/legacy/build/pdf"; // When upgrading pdfjs-dist library, also replace PDFReaderVendor.scss with pdfjs-dist/legacy/web/pdf_viewer.css and fix errors
import { EventBus, PDFLinkService, PDFViewer } from "pdfjs-dist/legacy/web/pdf_viewer"
import throttle from 'lodash/throttle'

import {initPdfWorker} from "../helpers/PdfWorker";

import '../scss/PDFReader.scss'


class PDFReader extends Component {
  
  constructor (props) {
    super(props)
    this.initEventBus()
    this.state = {
      doc: null,
      scale: null
    }

    this.progressPercentage = -1
    PDFJSLib.GlobalWorkerOptions.workerPort = initPdfWorker();
  }
  
  initEventBus () {
    this.eventBus = new EventBus()
    
    this.eventBus.on('pagesinit', (e) => {
      this.reader.currentScaleValue = 'auto'
      this.readerElement.scrollTo(0, 0)
      this.props.onPagesInit()
    })
    
    this.eventBus.on('pagechanging', (e) => {
      this.props.onPageChange(e.pageNumber);
    })
  }
  
  componentDidMount () {
    this.loadingStarted = (new Date()).getTime()

    this.pdfLinkService = new PDFLinkService();
    this.reader = new PDFViewer({
      container: ReactDOM.findDOMNode(this),
      eventBus: this.eventBus,
      linkService: this.pdfLinkService
    })
    this.pdfLinkService.setViewer(this.reader);

    const loadingTask = PDFJSLib.getDocument(this.props.uri)
    loadingTask.onProgress = (progress) => {
      const timeDiff = (new Date()).getTime() - this.loadingStarted

      let total = progress.total
      if (!total) {
        total = progress.loaded + (Math.log(timeDiff) * 65536 * 5)
      }

      const percentage = (progress.loaded / total) * 100
      if (percentage < this.progressPercentage) return;

      this.progressPercentage = percentage
      this.props.onLoadingProgress(percentage)
    }

    loadingTask.promise.then(doc => {
      this.reader.setDocument(doc)
      this.pdfLinkService.setDocument(doc)
      this.props.onDocumentLoaded(doc)
      this.props.onLoadingProgress(100)

      if (this.isSafariOrIE11()) return;
      doc.getPage(1).then((page) => { this.renderPageCanvas(doc, page, 1)});
    }).catch(e => {
      this.props.onError('Failed to load PDF', e)
    })

    window.addEventListener('resize', () => {
      this.throttledWindowResize()
    })
  }

  isSafariOrIE11() {
    return window.onbeforeprint === undefined || window.onafterprint === undefined // Safari
        || (window.navigator && window.navigator.msSaveOrOpenBlob && !!window.MSInputMethodContext && !!document.documentMode); // IE11
  }

  renderPageCanvas(doc, page, currentPageIdx) {
    const viewport = page.getViewport({scale: 1.0}); // This gives us the page's dimensions at full scale
    let canvas = document.createElement( 'canvas' ); // Create a canvas for each page to draw it on
    canvas.style.display = 'none';
    canvas.classList.add('canvas-print');

    const PRINT_UNITS = 300 / 72.0;
    canvas.height = Math.floor(viewport.height * PRINT_UNITS);
    canvas.width = Math.floor(viewport.width * PRINT_UNITS);

    let ctx = canvas.getContext('2d');
    ctx.save();
    ctx.fillStyle = 'rgb(255, 255, 255)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.restore();

    const renderContext = { canvasContext: ctx, transform: [ PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0 ], viewport: viewport };

    page.render(renderContext).promise.then(() => {
      document.body.appendChild(canvas);

      currentPageIdx++;
      if (doc !== null && currentPageIdx <= doc.numPages) {
        doc.getPage(currentPageIdx).then((page) => { this.renderPageCanvas(doc, page, currentPageIdx) });
      }
    }).catch(e => {
      this.props.onError('Failed to load PDF', e)
    });
  }

  throttledWindowResize = throttle(() => {
    this.reader.currentScaleValue = 'auto'
  }, 200)
  
  componentWillReceiveProps (nextProps) {
    if (nextProps.toolbarSetPage && nextProps.toolbarSetPage !== this.props.toolbarSetPage) {
      this.reader.currentPageNumber = nextProps.toolbarSetPage
    }

    if (nextProps.scale !== this.props.scale) {
      this.reader.currentScale = nextProps.scale
    }
  }

  throttledHandleScroll = throttle(() => {
    const maximumPagePosition = window.innerHeight / document.querySelector(`.page[data-page-number="${this.reader.currentPageNumber}"]`).getBoundingClientRect().bottom
    this.props.onScroll(maximumPagePosition)
  }, 200)

  handleScroll = (e) => {
    this.throttledHandleScroll()
  }
  
  render () {
    return (
      <div className="PDFReader" ref={el => this.readerElement = el} onScroll={this.handleScroll}>
        <div className="PDFReader-document pdfViewer"></div>
        {this.props.children}
      </div>
    )
  }
}

export default PDFReader
